module.exports = __webpack_public_path__ + "img/transfer-error.01591cab.svg";